module.exports = __webpack_public_path__ + "img/strip-2.799153e5.svg";